function customFilter() {
  if (!$("#filters>.h2").length) {
    $("#filters").prepend('<div class="h2">Filtrovat</div><button class="CloseFilters closeTop" type="button" title="Filtrovat"></button>').append('<div class="bottomFilterButton"><button class="CloseFilters closeBottom btn-conversion btn btn-primary" type="button" title="Filtrovat">Filtrovat</button></div>');
  }

  $("#filters .filter-sections").append($("#filters .slider-wrapper"));
  $(".slider-wrapper").addClass("filter-section");
  if (!$(".filter-section-boolean .param-filter-top>h4").length) {
    $(".filter-section-boolean .param-filter-top")
      .addClass("filter-section")
      .prepend("<h4><span>" + "Příznaky" + "</span></h4>")
      .prependTo(".filter-sections");
  }
  $("body")
    .off("click.customFilter", "#filters .filter-section h4")
    .on("click.customFilter", "#filters .filter-section h4", function () {
      $(this).closest(".filter-section").toggleClass("openIt");
    });

  $(".filter-section").addClass("openIt");
  var otherElements = $(".filter-section").not(openFilters.join(","));
  otherElements.removeClass("openIt");
  $(".filter-section").each(function () {
    if ($(this).find(".filter-label.active").length) {
      $(this).addClass("openIt");
    }
  });
}
function priceNumber(text) {
  return parseInt(String(text).replace(/\D/g, ""), 10);
}

function formatThousands(n) {
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

// zvolený rozsah ceny, nebo null když odpovídá celé kategorii
function activePriceRange() {
  const $slider = $("#filters #slider").closest(".slider-wrapper");
  if (!$slider.length) {
    return null;
  }
  const min = priceNumber($slider.find("#min").text());
  const max = priceNumber($slider.find("#max").text());
  const boundMin = priceNumber($slider.find("#categoryMinValue").text());
  const boundMax = priceNumber($slider.find("#categoryMaxValue").text());
  if ((min && boundMin && min !== boundMin) || (max && boundMax && max !== boundMax)) {
    return { min: min, max: max };
  }
  return null;
}

// label ceny – odebere priceMin/priceMax z URL a načte výpis
$(document)
  .off("click.resetPriceFilter", ".chooseFilters .filter-label--range")
  .on("click.resetPriceFilter", ".chooseFilters .filter-label--range", function () {
    const url = window.location.href
      .split("#")[0]
      .replace(/([?&])price(Min|Max)=[^&]*/g, "$1")
      .replace(/[?&]+$/, "")
      .replace(/\?&+/, "?")
      .replace(/&{2,}/g, "&");
    if (typeof makeFilterAjaxRequest === "function") {
      makeFilterAjaxRequest(url, true, false, this, "ShoptetPagePriceFilterChange");
    } else {
      window.location.href = url;
    }
  });

function showActiveFilters() {
  const $activeLabels = $(".filter-label.active");
  const price = activePriceRange();
  const hasActive = $activeLabels.length > 0 || !!price;
  let $wrapper = $(".chooseFilters");
  if (!hasActive) {
    $wrapper.remove();
  } else {
    if (!$wrapper.length) {
      $wrapper = $('<div class="chooseFilters"></div>').insertAfter("#category-header");
    }
    $wrapper.empty();

    if (price) {
      const currency = (window.shoptet && shoptet.config && shoptet.config.currencySymbol) || "Kč";
      const $priceLabel = $('<label class="filter-label filter-label--range" data-reset="price"></label>');
      $("<span>", { class: "name", text: "Cena:" }).appendTo($priceLabel);
      $("<span>", {
        class: "value",
        text: formatThousands(price.min) + " " + currency + " – " + formatThousands(price.max) + " " + currency,
      }).appendTo($priceLabel);
      $wrapper.append($priceLabel);
    }

    $activeLabels.each(function () {
      const $sourceLabel = $(this);
      const sectionName = $sourceLabel.closest(".filter-section").find("h4").first().text().trim();
      const filterValue = $sourceLabel.clone().children(".filter-count").remove().end().text().trim();
      const $label = $sourceLabel.clone().removeClass("active");

      $("<span>", { class: "name", text: sectionName + ":" }).prependTo($label);
      if ($sourceLabel.closest(".advanced-filters-wrapper").length) {
        const colorStyle = $sourceLabel.siblings(".advanced-parameter").find(".advanced-parameter-inner").attr("style");
        if (colorStyle) {
          $("<div>", { style: colorStyle }).insertBefore($label.children(".name"));
        }
      }
      $("<span>", { class: "value", text: filterValue }).insertBefore($label.children(".filter-count").first());
      $label
        .contents()
        .filter(function () {
          return this.nodeType === Node.TEXT_NODE;
        })
        .remove();

      $wrapper.append($label);
    });

    const $clear = $("#clear-filters");
    if ($clear.length) {
      const $clearClone = $clear.clone(true, true);

      $clearClone.addClass("clear-all-filters").find("a").text("Smazat filtry");

      $wrapper.append($clearClone);
    }
  }

  $(document)
    .off("click.showActiveFilters", ".chooseFilters label.filter-label")
    .on("click.showActiveFilters", ".chooseFilters label.filter-label", function () {
      const scrollTop = $(window).scrollTop();

      requestAnimationFrame(function () {
        $(window).scrollTop(scrollTop);
      });

      setTimeout(function () {
        $(window).scrollTop(scrollTop);
      }, 50);
    });
}

function sklonujProdukt(totalProducts) {
  totalProducts = parseInt(totalProducts, 10) || 0;

  if (totalProducts === 1) {
    return `<b>${totalProducts}</b> produkt`;
  }
  if (totalProducts >= 2 && totalProducts <= 4) {
    return `<b>${totalProducts}</b> produkty`;
  }
  return `<b>${totalProducts}</b> produktů`;
}

function truncateHtml($element, limit) {
  const clone = $element.clone();
  const walker = document.createTreeWalker(clone[0], NodeFilter.SHOW_TEXT);
  let remaining = limit;
  let textNode;

  while ((textNode = walker.nextNode())) {
    const text = textNode.nodeValue;
    if (text.length <= remaining) {
      remaining -= text.length;
      continue;
    }

    textNode.nodeValue = text.slice(0, remaining).replace(/\s+\S*$/, "") + "...";
    let node = textNode;

    while (node && node !== clone[0]) {
      while (node.nextSibling) {
        node.parentNode.removeChild(node.nextSibling);
      }
      node = node.parentNode;
    }
    break;
  }

  return clone.html();
}

function truncateCategoryPerex() {
  if (!$("body.mobile").length) {
    return;
  }

  $(".category-perex").each(function () {
    const limit = 400;
    const $perex = $(this);

    if ($perex.data("categoryPerexTruncated")) {
      return;
    }

    // .bigImg musí zůstat mimo zkracovaný obsah, nesahat na něj
    let $content = $perex.children(".category-perex-content");
    if (!$content.length) {
      $content = $perex.children().not(".bigImg").wrapAll('<div class="category-perex-content"></div>').parent();
    }

    if ($.trim($content.text()).length <= limit) {
      return;
    }

    const fullHtml = $content.html();
    $content
      .html('<div class="category-perex-short">' + truncateHtml($content, limit) + "</div>")
      .append('<button type="button" class="show-more btn-arrow">číst více</button>');

    $perex
      .data("categoryPerexTruncated", true)
      .off("click.categoryPerex", ".show-more")
      .on("click.categoryPerex", ".show-more", function () {
        $perex.removeData("categoryPerexTruncated");
        $content.html(fullHtml);
      });
  });
}

function customCategory() {
  if (!$(".sidebar > .needHelp").length) {
    $(".sidebar").append($("#footer .needHelp").clone());
  }
  var totalProducts = parseInt($(".itemsTotal strong").first().text().replace(/\D/g, ""), 10) || 0;
  var pageProductsCount = $(".products-page .product").length;

  $(".itemTotalCount").remove();
  $("#category-header").append('<div class="itemTotalCount"><p>Zobrazeno <b>' + pageProductsCount + "</b> z " + sklonujProdukt(totalProducts) + "</p></div>");

  truncateCategoryPerex();

  $("a.pagination__link--prev").closest("li").addClass("prev");
  $("a.pagination__link--next").closest("li").addClass("next");
}
function customSorting() {
  if (!$(".category-content-wrapper>.customSorting").length) {
    $(".category-content-wrapper").prepend('<span class="customSorting btn btn-primary">Seřadit dle</span>');
  }
}

function slickProductsTop() {
  var $productsTop = $("body.type-category #productsTop");

  if (!$productsTop.length || !$.fn.slick || $productsTop.hasClass("slick-initialized")) {
    return;
  }

  $productsTop.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: false,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3, slidesToScroll: 1 },
      },
      {
        breakpoint: 991,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
}

$("html").on("click", ".customSorting", function () {
  $("#category-header").toggleClass("show");
  $(this).toggleClass("active");
});

$("html")
  .off("click.customFilterClose", ".filters .CloseFilters")
  .on("click.customFilterClose", ".filters .CloseFilters", function () {
    $(".filters-unveil-button-wrapper a").trigger("click");
    $(".filters-unveil-button-wrapper a").text("Filtrovat").attr("data-text", "Zavřít filtr ");
  });

// Filtr je jako overlay do 991 px (ne jen na body.mobile) - Shoptet ho ale může nechat s třídou .visible
// i bez body.filters-visible, pak je otevřený hned po načtení.
function hideFiltersOverlay() {
  if (window.matchMedia("(max-width: 991px)").matches && !$("body").hasClass("filters-visible")) {
    $("#filters").removeClass("visible");
  }
}

// 768-991 px: sidebar je schovaný, takže .filters-wrapper (tlačítko Filtrovat + overlay filtru) se přesune do
// #filters-wrapper v obsahu, jako na telefonu (tam to dělá Shoptet sám). Mimo tento rozsah se vrátí do sidebaru.
function moveFiltersWrapper() {
  const $filters = $(".filters-wrapper").first();
  const $target = $("#filters-wrapper");
  if (!$filters.length || !$target.length) return;

  const isTablet = window.matchMedia("(min-width: 768px) and (max-width: 991px)").matches;

  if (isTablet) {
    if ($filters.parent().is($target)) return;
    $filters.data("sidebarParent", $filters.parent());
    $target.append($filters);
  } else {
    const $parent = $filters.data("sidebarParent");
    if ($parent && $parent.length && $filters.parent().is($target)) {
      $parent.prepend($filters);
      $filters.removeData("sidebarParent");
    }
  }
}

function initFilterHint() {
  moveFiltersWrapper();
  $(document).ready(function () {
    $(".filters-unveil-button-wrapper a").text("Filtrovat").attr("data-text", "Zavřít filtr ");

    hideFiltersOverlay();
  });
  customFilter();
  customSorting();
  showActiveFilters();
  customCategory();
  slickProductsTop();
}

if ($(".type-category").length) {
  $(document).ready(function () {
    hideFiltersOverlay();
  });

  $(window).on("resize.moveFiltersWrapper", moveFiltersWrapper);
  $(document).ready(initFilterHint);
  document.addEventListener("ShoptetDOMPageContentLoaded", initFilterHint);
  document.addEventListener("ShoptetPageSortingChanged", initFilterHint);
  document.addEventListener("ShoptetDOMPageMoreProductsLoaded", initFilterHint);
  document.addEventListener("ShoptetDOMContentLoaded", initFilterHint);
}
